var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-skeleton-loader",class:("c-skeleton-loader--" + _vm.type),style:({ height: _vm.height, width: _vm.computedWidth, 'border-radius': _vm.borderRadius })})}
var staticRenderFns = []

export { render, staticRenderFns }